import React from 'react';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import Hamburger from './Hamburger';

export default function NawigacjaGora({ stanMenu, zmienMenu, czyCzarnyTekst }) {


    return (

        <div id='nav-wrapper' className={`fixed top-0 left-0 
                                        w-full ${czyCzarnyTekst ? 'text-black' : 'text-white'} px-10 py-6 font-sen z-50`}>
            <div className='flex justify-between items-center space-x-4'>
                <div className='flex justify-start gap-16'>
                    <div className='text-xl cursor-pointer 
                                hover:translate-x-1 hover:opacity-80 transition-all duration-500 
                                ease-in-out tracking-widest'>
                        <a href='/portfolio/'>Jakub Bednarek</a>
                    </div>
                    <div className='text-xl cursor-pointer 
                                hover:translate-x-1 hover:opacity-80 transition-all duration-500 
                                ease-in-out tracking-widest'>
                        <a href='https://destray32.github.io/ml-blog/' className=''>ML Blog</a>
                    </div>
                </div>
                <div className='flex items-center space-x-[5rem]'>
                    <a href='https://github.com/Destray32/' className='ikona-nav hidden sm:block'>
                        <AiFillGithub size={44} />
                    </a>

                    <a href='https://www.linkedin.com/in/jakub-bednarek-79a5bb243/' className='ikona-nav hidden sm:block'>
                        <AiFillLinkedin size={44} />
                    </a>
                    <Hamburger stanMenu={stanMenu} callback={zmienMenu} czyCzarne={czyCzarnyTekst} />
                </div>
            </div>
        </div>

    )

}